export interface TouchMacroAction {
  action: 'down' | 'move' | 'up';
  timing: number;
  x: number;
  y: number;
  touchId?: number;
}

/** Backward-compatible touch DSL: omitted identity means contact zero. */
export class TouchMacroCodec {
  public static validateSequence(macros: readonly string[]): boolean {
    const held = new Set<number>();
    for (const macro of macros) {
      if (!macro.startsWith('touch=')) continue;
      const action = this.decode(macro);
      if (!action) return false;
      const id = action.touchId ?? 0;
      if (action.action === 'down') {
        if (held.has(id) || held.size >= 10) return false;
        held.add(id);
      } else {
        if (!held.has(id)) return false;
        if (action.action === 'up') held.delete(id);
      }
    }
    return held.size === 0;
  }
  public static decode(value: string): TouchMacroAction | null {
    const match = /^touch=(down|move|up)(?:@(\d+))?\^(\d+(?:\.\d+)?),(\d+(?:\.\d+)?)(?:,(\d+))?$/.exec(value);
    if (!match) return null;
    const timing = Number(match[2] ?? 100), x = Number(match[3]), y = Number(match[4]);
    const touchId = Number(match[5] ?? 0);
    if (!Number.isSafeInteger(timing) || timing > 600000 || x > 1 || y > 1
      || !Number.isInteger(touchId) || touchId > 255) return null;
    return { action: match[1] as TouchMacroAction['action'], timing, x, y,
      ...(match[5] === undefined ? {} : { touchId }) };
  }
  public static encode(action: TouchMacroAction): string {
    const value = `touch=${action.action}@${action.timing}^${action.x},${action.y}`
      + (action.touchId === undefined ? '' : `,${action.touchId}`);
    if (!this.decode(value)) throw new Error('Invalid touch macro');
    return value;
  }
}
